import * as yup from 'yup';
import i18next from 'i18next';

export default yup.object().shape({
  name: yup.string().trim().required(),
  idp: yup.string().trim().required(),
  description: yup.string().trim(),
  customFields: yup.array(),
  entityId: yup
    .string()
    .trim()
    .required(
      i18next.t('shared.integrations.ssoIntegrations.form.validations.entityId')
    ),
});
